var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
var CalenderIcon = function (props) {
    return (_jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none" }, props, { children: _jsx("path", { d: "M7 1V3M17 1V3M2 8H22M7.5 13H9.5M14.5 13H16.5M7.5 17H9.5M14.5 17H16.5M5 22H19C20.6569 22 22 20.6569 22 19V6C22 4.34315 20.6569 3 19 3H5C3.34315 3 2 4.34315 2 6V19C2 20.6569 3.34315 22 5 22Z", stroke: "#6E7191", "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round" }) })));
};
export default CalenderIcon;
